import React, { useEffect, useMemo, useState } from "react";
import "./flights-booking-detail-page.scss";
import { CountdownText } from "../../ui/commons/CountdownText";
import { useParams, Link } from "react-router-dom";
import { get } from "../../../utils/request";
import Navbar from "../../Navbar/Navbar";
import { Typography, Button, Divider, Breadcrumb, Collapse } from 'antd';
import {
  QrcodeOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import KycDialog from "../../ui/commons/KycDialog";
import EsimLocationDialog from "../../ui/commons/EsimLocationDialog";
import { toast } from "react-toastify";
import {post} from "../../../utils/request";
import Footer from "../../Footer/Footer";
import FlightIcon from '@mui/icons-material/Flight';
import { UserOutlined, PhoneOutlined } from '@ant-design/icons';
import { TicketsPlane, Luggage} from "lucide-react";
import {FlightsBaggageAllowance} from './FlightsBaggageAllowance';
import { customerOrderNumber, formatBookingDate } from "../bookingDisplay";


const { Text, Title } = Typography;

const { Panel } = Collapse;


const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });


export const FlightsBookingDetailPage = ({  }) => {
  const { bookingId } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [order, setOrder] = useState(null);

  const [paying, setPaying] = useState(false);

  useEffect(() => {
    fetchBookingDetail();
  }, [bookingId]);

  const fetchBookingDetail = async () => {
    try {
      setIsLoading(true);
      const result = await get(`/order/flights/${bookingId}`);
      setOrder(result);
      setIsLoading(false);
    } catch (error) {
      console.log(error);

      setIsLoading(false);
    }
  };

  const paymentNotify = async (paymentId) => {
    try {
      if (!paymentId) return;
      await post(`/payment/${paymentId}/notify`);
    } catch {
      // non-blocking
    }
  };

  const onPay = async () => {
    if (paying) return;

    setPaying(true);
    try {
      const paymentResult = await post("/payment/pay", {
        orderId: bookingId,
        serviceType: "flights",
      });

      const payResult = paymentResult?.payResult;
      if (!payResult) {
        toast.error("Something went wrong, please try again.");
        return;
      }

      const options = {
        key: payResult.appkey,
        order_id: payResult.providerOrderId,
        amount: payResult.amount,
        currency: payResult.currency,
        name: payResult.name,
        description: payResult.description,
        timeout: payResult.timeout,
        handler: async () => {
          await paymentNotify(payResult.paymentId);
          await fetchBookingDetail();
          setPaying(false);
        },
        prefill: {
          name: payResult.fullName,
          email: payResult.email,
          contact: payResult.contact,
        },
        theme: { color: "#3399cc" },
        // callback_url: `/my-bookings/flights/${orderId}`,
        // redirect: true
      };

      if (!window.Razorpay) {
        const loaded = await loadRazorpayScript();
        if (!loaded) {
          toast.error("Payment system failed to load. Please try again.");
          return;
        }
      }

      var rzp = new window.Razorpay(options)

      rzp.on('payment.failed', function (response){
        toast.error("Payment failed");
      });

      rzp.open();
    } catch (err) {
      console.error("Payment Error:", err);
      toast.error("Something went wrong, please try again.");
    } finally {
      setPaying(false);
    }
  };

  if (isLoading) {
    return (
      <div className="flights-page">
        <div className="flights-page__loading">
          <div className="spinner" />
        </div>
      </div>
    );
  }

  //   if (error) {
  //     return (
  //       <div className="flights-page">
  //         <header className="flights-page__header">
  //           <button className="flights-page__back-btn" onClick={onBack}>
  //             ←
  //           </button>
  //           <h1 className="flights-page__title">eSim Booking Detail</h1>
  //         </header>
  //         <div className="flights-page__error">
  //           <p>{error}</p>
  //           {onRetry && (
  //             <button className="btn btn--primary" onClick={onRetry}>
  //               Retry
  //             </button>
  //           )}
  //         </div>
  //       </div>
  //     );
  //   }

  //   if (!order) {
  //     return (
  //       <div className="flights-page">
  //         <header className="flights-page__header">
  //           <button className="flights-page__back-btn" onClick={onBack}>
  //             ←
  //           </button>
  //           <h1 className="flights-page__title">eSim Booking Detail</h1>
  //         </header>
  //         <div className="flights-page__not-found">Order not found</div>
  //       </div>
  //     );
  //   }

  return (
    <>
      <Navbar />
      <div className="flights-layout-content">
        <section className="container p-0">
          <div className="flights-page">
            <div className="breadcrumb">
              <Breadcrumb
                items={[
                  {
                    title: (
                      <Link to="/my-profile" state={{ activeTab: "bookings" }}>
                        My Bookings
                      </Link>
                    ),
                  },
                  {
                    title: (
                      <Link
                        to="/my-profile"
                        state={{ activeTab: "bookings", tab: "flights" }}
                      >
                        Flights
                      </Link>
                    ),
                  },
                  {
                    title: "Booking Details",
                  },
                ]}
              />
            </div>
            <header className="flights-page__header">
              <div>
                <div className="booking-detail-eyebrow">Flight booking</div>
                <Title level={2} style={{ margin: 0 }}>
                  Flight Booking
                </Title>
                <Text className="booking-detail-subtitle">
                  {order ? `Order ${customerOrderNumber(order)}` : "Review your itinerary, passengers, and payment summary."}
                </Text>
              </div>
              {!!order?.status && (
                <span className="booking-detail-status">{order.status}</span>
              )}
            </header>

            {isLoading && (
              <div className="flights-page__loading">
                <div className="spinner" />
              </div>
            )}

            {!isLoading && !order && (
              <div className="flights-page__not-found">Order not found</div>
            )}

            {!isLoading && !!order && (
              <div className="flights-page-layout">
                <div className="flights-page__body">
                  {/* Payment Section */}
                  {order.status === "Awaiting payment" &&
                    order.paymentInfo?.timeout > 0 &&
                    order.paymentInfo &&
                    !order.kycInfo && (
                      <PaymentCard
                        paymentInfo={order.paymentInfo}
                        orderId={order.orderId}
                        onPay={onPay}
                        onExpired={() => fetchBookingDetail()}
                      />
                    )}

                  {/* Booking Info */}
                  <OrderHeaderCard order={order} />

                  {/* Flight Journeys */}
                  {!!order.journeys?.length && (
                    <JourneySection journeys={order.journeys} />
                  )}

                  {/* Baggage */}
                  {!!order.tickets?.length && (
                    <BaggageSection
                      order={order}
                      onClick={() => {
                        // TODO: Open Modal
                      }}
                    />
                  )}

                  {/* Booking Reference */}
                  {!!order.pnrId && (
                    <BookingReferenceCard pnrId={order.pnrId} />
                  )}

                  {/* Tickets */}
                  {!!order.tickets?.length && (
                    <TicketsSection tickets={order.tickets} />
                  )}

                  {/* Passenger & Contact */}
                  {!!order.passengerInfos?.length && (
                    <PassengerContactCard
                      passengers={order.passengerInfos}
                      contactInfo={order.contactInfo}
                    />
                  )}
                </div>
                <div className="flights-page-right-seciton">
                  <OrderPriceCard order={order} />
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

const PaymentCard = ({ paymentInfo, orderId, onPay, onExpired }) => {
  return (
    <div className="card payment-card">
      <div className="payment-card__text">
        Complete payment before {paymentInfo.expireTime} to secure your booking.
      </div>
      <div className="payment-card__action">
        <Button
          className="pay-btn"
          onClick={() => onPay && onPay(orderId, "flights")}
        >
          <span>Pay</span>
          <CountdownText
            timeoutInSeconds={paymentInfo.timeout}
            onFinished={onExpired}
          />
        </Button>
      </div>
    </div>
  );
};

const OrderHeaderCard = ({ order }) => {
  return (
    <div className="card order-card">
      <div className="order-card__row">
        <div className="order-card__main">
          <div className="order-card__title-row">
            <h2 className="card-title">Booking Information</h2>
            {!order.kycInfo && (
              <span className="order-card__status">{order.status}</span>
            )}
          </div>
          <div className="order-card__meta">
            <div className="order-card__meta-item">
              Order No. {customerOrderNumber(order)}
            </div>
            <div className="order-card__meta-item">
              Booking Date: {formatBookingDate(order.orderDate, true) || "Not available"}
            </div>
          </div>
          {/* <div className="order-card__amount">
            Total <span>{order.displayAmount}</span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

const OrderPriceCard = ({ order}) => {
  return (
    <div className="card flights-card">
      <div className="total-price-info-row">
        <div className="total-price-info-row__label">{order.priceInfo.totalPrice.title}</div>
        <div className="total-price-info-row__value">{order.priceInfo.totalPrice.content}</div>
      </div>
      
      <Divider dashed />

      {order.priceInfo.priceDetails.map((priceDetail, index) => (
        <div className="price-info-row" key={`${priceDetail.title}-${index}`}>
          <div className="price-info-row__label">{priceDetail.title}</div>
          <div className="price-info-row__value">{priceDetail.content}</div>
        </div>
      ))}
    </div>
  );
};

const InfoRow = ({ label, value }) => {
  if (!value) return null;
  return (
    <div className="info-row">
      <div className="info-row__label">{label}</div>
      <div className="info-row__value">{value}</div>
    </div>
  );
};

function formatRemainingTime(seconds) {
  if (seconds <= 0) return "Expired";
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  if (hrs > 0) return `${hrs}h ${mins}m`;
  return `${mins}m`;
}

const JourneySection = ({ journeys }) => {
  return (
    <div className="journey-section">
      {journeys.map((journey, index) => (
        <JourneyCard key={index} journey={journey} />
      ))}
    </div>
  );
};

const JourneyCard = ({ journey }) => {
  return (
    <div className="card journey-card">
      <div className="journey-card__top">
        <span>{formatDepartureDate(journey.departDateTime)}</span>
        <span className="divider" />
        <span>{formatDuration(journey.duration)}</span>
      </div>

      <FlightTimeline flightJourney={journey} showFlightInfo={true} />
    </div>
  );
};

const BaggageSection = ({ order }) => {
  return (
    <Collapse
      accordion
      bordered={true}
      className="baggage-collapse"
      expandIconPosition="right"
    >
      <Panel
        header={
          <div className="baggage-header">
            <Luggage size={20} />
            <span className="baggage-header-title">Baggage Allowance</span>
          </div>
        }
        key="1"
      >
        <FlightsBaggageAllowance journeys={order.journeys} />
      </Panel>
    </Collapse>
  );
};

const BookingReferenceCard = ({ pnrId }) => {
  return (
    <div className="card">
      <h3 className="card-title">Booking Reference</h3>

      <div className="pnr-row">
        <span className="pnr-label">PNR: </span>
        <span className="pnr-value">{pnrId}</span>
      </div>
    </div>
  );
};

const TicketsSection = ({ tickets }) => {
  return (
    <div className="card">
      <h3 className="card-title">Tickets</h3>

      {tickets.map((ticket, index) => (
        <TicketCard key={index} ticket={ticket} />
      ))}
    </div>
  );
};

const TicketCard = ({ ticket }) => {
  const fullName = `${ticket.firstName} ${ticket.lastName}`.trim();

  return (
    <div className="ticket-card">
      <div className="ticket-card__icon"><TicketsPlane /></div>

      <div className="ticket-card__content">
        <div className="ticket-card__name">
          {fullName || "-"}
        </div>

        <div className="ticket-card__label">
          Ticket No.
        </div>

        <div className="ticket-card__number">
          {ticket.ticketNumber}
        </div>
      </div>
    </div>
  );
};

const PassengerContactCard = ({ passengers, contactInfo }) => {
  return (
    <div className="card">
      <h3 className="card-title">Passenger & Contact Info</h3>

      <div className="passenger-list">
        {passengers.map((p, index) => (
          <div key={index} className="passenger-row">
            <span><UserOutlined /></span>
            <span className="passenger-name">
              {p.firstName} {p.lastName}
            </span>

            {p.type !== "Adult" && (
              <span className="passenger-tag">
                {p.type}
              </span>
            )}
          </div>
        ))}
      </div>

      <Divider />

      <div className="contact-info">
        <span><PhoneOutlined /></span>
        <span className="contact-name">
          {contactInfo.name}
        </span>

        <div className="contact-meta">
          {contactInfo.email} | {contactInfo.phoneAreaCode} {contactInfo.phoneNumber}
        </div>
      </div>
    </div>
  );
};

const FlightTimeline = ({ flightJourney, showFlightInfo = true }) => {
  const flights = flightJourney.flights || [];

  return (
    <div className="flight-timeline">
      {flights.map((flight, index) => (
        <React.Fragment key={index}>
          
          {/* Transfer */}
          {index > 0 && (
            <TransferRow
              city={
                flight.departure?.cityName ||
                flight.departure?.city ||
                ""
              }
              duration={flight.transferDuration}
            />
          )}

          {/* Departure */}
          <TimelineRow
            type="depart"
            time={formatTime(flight.departDateTime)}
            dayCount={flight.departDayCount}
            label={buildLocationLabel(flight.departure)}
          />

          {/* Flight Info */}
          {showFlightInfo && (
            <FlightInfoRow flight={flight} />
          )}

          {/* Arrival */}
          <TimelineRow
            type="arrive"
            time={formatTime(flight.arriveDateTime)}
            dayCount={flight.arriveDayCount}
            label={buildLocationLabel(flight.arrival)}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

const TimelineRow = ({ type, time, dayCount, label }) => {
  return (
    <div className="timeline-row">
      <div className="timeline-left">
        <div className="timeline-dot" />
      </div>

      <div className="timeline-time">
        {dayCount > 0 && (
          <div className="timeline-day">
            +{dayCount} day
          </div>
        )}
        <div className="timeline-clock">
          {time}
        </div>
      </div>

      <div className="timeline-label">
        {label}
      </div>
    </div>
  );
};

const TransferRow = ({ city, duration }) => {
  return (
    <div className="transfer-row">
      <div className="timeline-left">
        <div className="timeline-transfer-line" />
      </div>

      <div className="timeline-time" />

      <div className="timeline-label transfer-text">
        Transfer in {city}, {formatDuration(duration)}
      </div>
    </div>
  );
};

const FlightInfoRow = ({ flight }) => {
  return (
    <div className="flight-info-row">
      <div className="timeline-left" />

      <div className="timeline-time" />

      <div className="timeline-label">
        <div className="flight-meta-top">
          {flight.airline?.brandmarkUrl ? (
            <img
              src={flight.airline.brandmarkUrl}
              alt=""
              className="airline-logo"
            />
          ) : (
            <span
              className="airline-logo-fallback"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <FlightIcon style={{ fontSize: 15 }} />
            </span>
          )}

          <span>
            {flight.airline?.name} {flight.flightNo}
          </span>

          <span className="meta-divider" />

          <span>{flight.cabinName}</span>

          {flight.aircraftTypeName && (
            <>
              <span className="meta-divider" />
              <span>{flight.aircraftTypeName}</span>
            </>
          )}
        </div>

        <div className="flight-duration">
          Flight time: {formatDuration(flight.duration)}
        </div>
      </div>
    </div>
  );
};

function formatTime(iso) {
  if (!iso) return "";

  const [datePart, timePart] = iso.split("T");
  const [hour, minute] = timePart.split(":");

  return `${hour}:${minute}`;
}

function formatDuration(totalMinutes) {
  if (!totalMinutes) return "";
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}m`;
}

function buildLocationLabel(location) {
  if (!location) return "";

  const airport = location.airport || "";
  const airportName = location.airportName || "";
  const cityName = location.cityName || "";
  const terminal = location.terminal || "";

  const name = airportName.startsWith(cityName) ? airportName : `${cityName} ${airportName}`;

  return `${airport} ${name} ${terminal}`;
}

function formatDepartureDate(dateTimeStr) {
  const dateTime = new Date(dateTimeStr);
  const options = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' };
  return dateTime.toLocaleDateString('en-US', options);
}
